/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injection volume scales with column volume (diameter² × length); gradient time scales with column volume divided by the flow-rate change.`)
};

const es_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El volumen de inyección escala con el volumen de la columna (diámetro² × longitud); el tiempo de gradiente escala con el volumen de la columna dividido por el cambio de caudal.`)
};

const de_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Injektionsvolumen skaliert mit dem Säulenvolumen (Durchmesser² × Länge); die Gradientenzeit skaliert mit dem Säulenvolumen geteilt durch die Änderung der Flussrate.`)
};

const nl_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injectievolume schaalt met het kolomvolume (diameter² × lengte); gradiënttijd schaalt met het kolomvolume gedeeld door de verandering in flowsnelheid.`)
};

const fr_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le volume d'injection s'adapte au volume de la colonne (diamètre² × longueur) ; le temps de gradient s'adapte au volume de la colonne divisé par le changement de débit.`)
};

const it_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il volume di iniezione scala con il volume della colonna (diametro² × lunghezza); il tempo di gradiente scala con il volume della colonna diviso per la variazione di portata.`)
};

const pt_br2_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O volume de injeção escala com o volume da coluna (diâmetro² × comprimento); o tempo de gradiente escala com o volume da coluna dividido pela variação de vazão.`)
};

const pt_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O volume de injeção escala com o volume da coluna (diâmetro² × comprimento); o tempo de gradiente escala com o volume da coluna dividido pela alteração do caudal.`)
};

const ja_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注入量はカラム体積(直径² × 長さ)に比例し、グラジエント時間はカラム体積を流速の変化で割った値に比例します。`)
};

const zh_hplc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进样量随柱体积（内径² × 柱长）变化；梯度时间随柱体积除以流速变化量变化。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_a3", locale)
	if (locale === "en") return en_hplc_faq_a3(inputs)
	if (locale === "es") return es_hplc_faq_a3(inputs)
	if (locale === "de") return de_hplc_faq_a3(inputs)
	if (locale === "nl") return nl_hplc_faq_a3(inputs)
	if (locale === "fr") return fr_hplc_faq_a3(inputs)
	if (locale === "it") return it_hplc_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_a3(inputs)
	if (locale === "pt") return pt_hplc_faq_a3(inputs)
	if (locale === "ja") return ja_hplc_faq_a3(inputs)
	return zh_hplc_faq_a3(inputs)
};